import getValue from './getValue';

export default function isValueChange(newOption, oldOption) {
	const oldValue = getValue(newOption);
	const newValue = getValue(oldOption);

	return oldValue !== newValue;
}
